import { LOGOS, Region } from "../Header";
import clsx from "clsx";
import { Divider } from "@/components/ui/Divider";
import "./HeaderPostLogin.scss";
import { ComponentType, ReactNode } from "react";
import { Col, Row } from "@/components";
import { CircleRightArrow, CirlceLeftArrow } from "@/icons";

type NavigationItem = {
  label: string;
  href: string;
  icon?: ComponentType<any>;
  active?: boolean;
  isNewTab?: boolean;
};

export type HeaderPostLoginProps = {
  shortTitle: ReactNode;
  region: Region;
  navigationItems: NavigationItem[];
  loginLink?: string;
  asLink?: "a" | ComponentType<any>;
  generalClassName?: string;
  navItemsClassName?: string;
  isExpanded?: boolean;
  toggleExpand?: () => void;
  expandTitle?: string;
  subtitle?: string;
  variant?: "operators" | "default"
};

export const HeaderPostLogin = ({
  shortTitle,
  region,
  asLink = "a",
  navigationItems,
  generalClassName,
  navItemsClassName,
  isExpanded = true,
  expandTitle = "Apri",
  subtitle = "",
  variant = "default",
  toggleExpand,
}: HeaderPostLoginProps) => {
  const LinkComponent = asLink;
  const NationalIcon = LOGOS["nazionale"];
  const RegionIcon = LOGOS[region];

  const dividerPadding = variant === "default" ? (isExpanded ? "p-x40" : "py-x40") : (isExpanded ? "p-x20" : "pt-x12 pb-x40")

  return (
    <nav
      role="navigation"
      className={clsx(
        "ui-hpl-menu",
        generalClassName,
        isExpanded ? "expanded" : "closed",
      )}
      style={
        {
          "--navbar-elements": navigationItems.length ?? 0,
        } as React.CSSProperties
      }
    >
      <Col
        pt={"x80"}
        px={isExpanded ? "x40" : (variant === "default" ? "x20" : "x16")}
        gap={"x16"}
        justifyContent={"center"}
        className="position-relative"
      >
        <Row
          gap={isExpanded ? "x24" : "x12"}
          alignItems={"center"}
          justifyContent={"center"}
        >
          <NationalIcon
            width={isExpanded ? 27 : 20}
            height={isExpanded ? 44 : 37}
          />
          <Divider bg="border-divider" direction="vertical" />
          <RegionIcon
            width={isExpanded ? 44 : 37}
            height={isExpanded ? 44 : 37}
          />
        </Row>
        <h1 className={clsx("shortTitle fs-custom fw-normal text-slate-20 text-align-center")}>
          {shortTitle}
        </h1>
        {subtitle &&
          <p className="fs-7 fw-semibold text-slate-52 text-center">{subtitle}</p>
        }
      </Col>
      <div className={dividerPadding}>
        <Divider bg="border-divider" />
      </div>
      <Col
        as={"ul"}
        gap={"x12"}
        className={clsx("list-style-none ui-hpl-list", navItemsClassName)}
        role="list"
      >
        {navigationItems.map((item, index) => {
          const IconComponent = item?.icon;
          return (
            <li
              key={index}
              className={clsx("ui-hpl-list-item", item.active && "active")}
            >
              <LinkComponent
                href={item.href}
                className={clsx(
                  "text-decoration-none text-primary fs-custom base-row gap-x16 align-items-center pr-x8",
                  item.active ? "fw-bold" : "fw-normal",
                )}
                target={item.isNewTab ? "_blank" : undefined}
                rel={item.isNewTab ? "noopener noreferrer" : undefined}
              >
                {IconComponent && (
                  <IconComponent color="primary" filled={item.active} />
                )}
                <span className="ui-hpl-text">{item.label}</span>
                {item.active && <span className="visually-hidden">Attivo</span>}
              </LinkComponent>
            </li>
          );
        })}
      </Col>
      <button onClick={toggleExpand} className="ui-toggle-menu-button py-x24">
        {isExpanded ? <CirlceLeftArrow /> : <CircleRightArrow />}
        {expandTitle}
      </button>
    </nav>
  );
};
